import Vue from "vue";
import Vuetify from "vuetify/lib/framework";
import config from "@/plugins/config.js";
import "@mdi/font/css/materialdesignicons.css";

Vue.use(Vuetify);
const opts = {
  icons: {
    iconfont: "mdi",
  },
  theme: {
    dark: false,
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        primary: config.themeEnvironment.primary,
        "primary-lighten-1": "#8B3AD5",
        "primary-darken-1": "#572C88",
        base: config.themeEnvironment.base,
        secondary: config.themeEnvironment.secondary,
        tertiary: config.themeEnvironment.tertiary,
        modal: config.themeEnvironment.modal,
        fourth: config.themeEnvironment.fourth,
        fourth_darken: "#2d1a4c",
        "custom-green": "#BCCF00",
        "custom-green-status": "#729917",
        "custom-red-status": "#fd2108",
        "custom-grey": "#CBCBCB",
        "custom-grey-2": "#E9E8ED",
        "custom-grey-3": "#49484B",
        "custom-grey-4": "#a9a9a9",
        black: "#0F0F10",
      },
    },
  },
};
export default new Vuetify(opts);
